export default "__VITE_ASSET__C2jLy3Xo__"